<template>
	<div class="box">
		<div class="row">
			<div class="col-10">
				<e-select
					id="stallions"
					v-model="stallions"
                    track-by="horse_id"
					label="horse_nom"
					:placeholder="$t('monte.semence.selectionnez_etalons')"
					:selectedLabel="$t('global.selected_label')"
					:options="all_stallions"
					:multiple="true"
					:loading="loading_stallion"
				>
					<template slot="noOptions">{{ $t('global.list_empty') }}</template>
				</e-select>
			</div>
			<div class="col-2">
				<b-button variant="primary" block @click="load_commandes">{{ $t('global.rechercher') }}</b-button>
			</div>
		</div>

		<CustomTable
            ref="table"
            id_table="ca_commandes"
            primaryKey="horse_id"
            :items="commandes"
            :busy.sync="table_busy"
            :checkboxes="false"
            :hrefsRoutes="config_table_hrefs"
        />

        <AddCommande ref="add_commande" @submit="load_commandes" />
	</div>
</template>

<script type="text/javascript">
	import Semence from "@/mixins/Semence.js"
    import Navigation from "@/mixins/Navigation.js"

	export default {
		name: 'Commandes',
		mixins: [Semence, Navigation],
		props: ['status'],
		data () {
			return {
				table_busy: false,
				commandes: [],
				all_status: [{
					code: 0,
					label: this.getTrad('monte.semence.status.cancel')
				},{
					code: 1,
					label: this.getTrad('monte.semence.status.save')
				},{
					code: 2,
					label: this.getTrad('monte.semence.status.accept')
				},{
					code: 3,
					label: this.getTrad('monte.semence.status.en_cours')
				},{
					code: 4,
					label: this.getTrad('monte.semence.status.ready')
				}],
				status_selected: [],
				all_stallions: [],
				stallions: [],
				loading_stallion: false,
                config_table_hrefs: {
                    'stallion.horse_nom': {
                        routeUniqueName: 'StallionCommandes',
                        routeName: 'StallionCommandes',
                        params: {
                            horse_id: 'stallion.horse_id'
                        }
                    }
                },
                events_tab: {
					'TableAction::goToAddCommandeSemence': () => {
						this.$refs.add_commande.openModal()
					},
				},
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.status_selected = this.all_status.filter(st => [1, 2].includes(st.code))
				if(this.status && this.status.length > 0) {
					this.status_selected = this.all_status.filter(st => this.status.includes(st.code))
				}

				this.loading_stallion = true
				this.all_stallions = await this.getStallions()
				this.loading_stallion = false

				this.load_commandes()
			},
			async load_commandes() {
				this.table_busy = true
				const horses_ids = this.stallions.map(horse => horse.horse_id)

				let commandes = await this.getCommandes(horses_ids, this.status_selected.map(st => st.code))
				commandes.forEach(exp => {
					exp.statut = this.getTrad('monte.semence.status.'+exp.semenceexpedition_status)
					exp.semenceexpedition_qte += ' ' + (exp.semenceexpedition_dose ? this.getTrad('monte.doses') : this.getTrad('monte.paillettes'))
				})
				this.commandes = commandes
				this.table_busy = false
			}
		},

		watch: {
			status(val) {
				if(val.length > 0) {
					this.status_selected = this.all_status.filter(st => val.includes(st.code))
				}
				this.load_commandes()
			}
		},

		components: {
			CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
			DateRangeV2: () => import('GroomyRoot/components/Inputs/DateRangeV2'),
			AddCommande: () => import('@/components/Semence/AddCommande')
		}
	}

</script>